import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { get } from "lodash";
import { mainMenu } from "@qlik/qlik/src/lib/menu";
import { toKebabCase } from "@qlik/qlik/src/lib/utils";
import LinkWithIcon from "@qlik/qlik/src/components/Header/Sub_Menu_Components/Link_With_Icon";

/**
 * SubmenuLayoutFive renders the right hand side of a main menu drop down, with
 * two columns (via CSS) of LinkWithIcon
 * e.g. solutions > by industry
 */
const SubmenuLayoutFive = ({ data: subItems, layoutType, layoutId, className = "", deviceType = "desktop" }) => {
    const allowedLayoutMap = get(mainMenu, `[${layoutType}]`);
    const allowedComponents = Object.keys(allowedLayoutMap);
    const layoutClass = toKebabCase(layoutType);

    return (
        <div
            className={`submenu-level-3 submenu--${layoutClass} ${className} xl:pt-10 xl:pb-14.75 relative`}
            data-parent={`${layoutClass}-${layoutId}`}
            data-device={`${deviceType}`}
        >
            <div className="-z-1 absolute max-xl:hidden bg-dropdownImage bg-contain -bottom-[312px] -right-[1085px] w-455 h-97.75" />
            <div className="flex-1">
                <ul className={`grid gap-x-15 gap-y-7.5 mt-5 grid-cols-1 lg:grid-cols-2 `}>
                    {subItems?.map((subItem) => (
                        <li key={subItem.id}>
                            <LinkWithIcon data={subItem} />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default SubmenuLayoutFive;
